import { comparisonData } from '@/mocks/home';

export default function ComparisonSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-label font-semibold text-primary-500 mb-2 tracking-wider uppercase">
            Comparison
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            저신용 사업자도{' '}
            <span className="text-primary-500">높은 승인율!</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label">
            타사 대비 압도적인 한도와 승인율을 직접 경험해 보세요.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full">
            <div className="bg-background-100 rounded-2xl md:rounded-3xl p-6 md:p-8 border border-background-200/70">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-shield-check-line w-5 h-5 flex items-center justify-center text-white" />
                </div>
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-900">승인 완료</p>
                  <p className="text-xs text-foreground-500 font-label">빠르고 정확한 심사 진행</p>
                </div>
              </div>

              <div className="flex items-center justify-center mb-6">
                <div className="relative">
                  <div className="w-40 h-40 md:w-48 md:h-48 rounded-full bg-primary-500 flex flex-col items-center justify-center text-white">
                    <span className="text-2xl md:text-3xl font-heading font-bold">8,000</span>
                    <span className="text-sm font-label">만원 승인</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-white" />
                  </div>
                </div>
              </div>

              <p className="text-center text-sm text-foreground-600 font-label">
                신청하신 대출이 <strong className="text-primary-600">승인처리</strong>되었습니다.
              </p>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="overflow-hidden rounded-2xl md:rounded-3xl border border-background-200/70">
              <div className="grid grid-cols-4 bg-background-100 p-4 text-center">
                <span className="text-xs md:text-sm font-label font-semibold text-foreground-500">구분</span>
                <span className="text-xs md:text-sm font-label font-semibold text-foreground-500">대출 한도</span>
                <span className="col-span-2 text-xs md:text-sm font-label font-semibold text-foreground-500">특징</span>
              </div>
              {comparisonData.map((row) => (
                <div
                  key={row.name}
                  className={`grid grid-cols-4 p-4 text-center items-center border-t border-background-200/50 ${
                    row.isHighlight ? 'bg-primary-50' : 'bg-white'
                  }`}
                >
                  <span
                    className={`text-sm md:text-base font-label font-semibold ${
                      row.isHighlight ? 'text-primary-700' : 'text-foreground-700'
                    }`}
                  >
                    {row.name}
                  </span>
                  <span
                    className={`text-sm md:text-base font-label font-medium ${
                      row.isHighlight ? 'text-primary-600' : 'text-foreground-600'
                    }`}
                  >
                    {row.limit.split('\n').map((line, i) => (
                      <span key={i}>
                        {line}
                        {i < row.limit.split('\n').length - 1 && <br />}
                      </span>
                    ))}
                  </span>
                  <span
                    className={`col-span-2 text-xs md:text-sm font-label ${
                      row.isHighlight ? 'text-primary-700' : 'text-foreground-500'
                    }`}
                  >
                    {row.feature.split('\n').map((line, i) => (
                      <span key={i}>
                        {line}
                        {i < row.feature.split('\n').length - 1 && <br />}
                      </span>
                    ))}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-3 bg-accent-50 rounded-xl p-4">
              <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-lightbulb-flash-line w-4 h-4 flex items-center justify-center text-white" />
              </div>
              <p className="text-sm font-label text-accent-900">
                <strong>프리미엄허브</strong>는 사업자의 매출과 사업성을 종합적으로 평가하여,
                신용점수와 무관하게 <strong>최대 10억원</strong>까지 신속하게 승인해 드립니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}